/* eslint-disable no-console */

const APP_SHELL_WORKER = `${process.env.BASE_URL}service-worker.js`;

const isAppShellWorker = (worker) => {
  const scriptURL = worker?.scriptURL || "";

  return scriptURL.endsWith(APP_SHELL_WORKER) || scriptURL.includes("/service-worker.js");
};

const unregisterAppShellWorkers = async () => {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();

    await Promise.all(
      registrations
        .filter((registration) =>
          [registration.active, registration.waiting, registration.installing].some(
            (worker) => isAppShellWorker(worker)
          )
        )
        .map((registration) => registration.unregister())
    );
  } catch (error) {
    console.error("Failed to unregister legacy app service worker:", error);
  }
};

unregisterAppShellWorkers();
